import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import CategoryListing from "./pages/CategoryListing";
import VenueDetail from "./pages/VenueDetail";
import BusinessRegister from "./pages/BusinessRegister";
import FirmaPanel from "./pages/FirmaPanel";
import AdminPanel from "./pages/AdminPanel";
import AdminFirmEdit from "./pages/AdminFirmEdit";
import AdminFirmManage from "./pages/AdminFirmManage";
import Araclar from "./pages/Araclar";
import ArticleDetail from "./pages/ArticleDetail";
import PaymentResult from "./pages/PaymentResult";
import MemberPanel from "./pages/MemberPanel";
import InvitationView from "./pages/InvitationView";
import { Toaster } from "./components/ui/toaster";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./context/AuthContext";
import { PageViewTracker } from "./components/PageViewTracker";
import { CategoriesProvider } from "./context/CategoriesContext";
import { MemberProvider } from "./context/MemberContext";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <MemberProvider>
          <CategoriesProvider>
          <PageViewTracker />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/kategori/:slug" element={<CategoryListing />} />
            <Route path="/araclar" element={<Araclar />} />
            <Route path="/rehber/:slug" element={<ArticleDetail />} />
            <Route path="/mekan/:slug" element={<VenueDetail />} />
            <Route path="/firma-kayit" element={<BusinessRegister />} />
            <Route path="/firma-panel" element={<FirmaPanel />} />
            <Route path="/uyelik" element={<MemberPanel />} />
            <Route path="/davetiye/:id" element={<InvitationView />} />
            <Route path="/patron" element={<AdminPanel />} />
            <Route path="/patron/firma/:id" element={<AdminFirmManage />} />
            <Route path="/patron/firma/:id/eski" element={<AdminFirmEdit />} />
            <Route path="/odeme/basarili" element={<PaymentResult success={true} />} />
            <Route path="/odeme/basarisiz" element={<PaymentResult success={false} />} />
            <Route path="/:categorySlug/:citySlug/:slug" element={<VenueDetail />} />
            <Route path="/:categorySlug/:citySlug" element={<CategoryListing />} />
          </Routes>
          </CategoriesProvider>
          </MemberProvider>
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
